import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-action-library",
  "use": "icon-action-library-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-action-library\"><path d=\"M945.230769 1024H630.153846a78.769231 78.769231 0 0 1-78.769231-78.769231V630.153846a78.769231 78.769231 0 0 1 78.769231-78.769231h315.076923a78.769231 78.769231 0 0 1 78.769231 78.769231v315.076923a78.769231 78.769231 0 0 1-78.769231 78.769231z m0-551.384615H630.153846a78.769231 78.769231 0 0 1-78.769231-78.769231V78.769231a78.769231 78.769231 0 0 1 78.769231-78.769231h315.076923a78.769231 78.769231 0 0 1 78.769231 78.769231v315.076923a78.769231 78.769231 0 0 1-78.769231 78.769231z m-551.384615 551.384615H78.769231a78.769231 78.769231 0 0 1-78.769231-78.769231V630.153846a78.769231 78.769231 0 0 1 78.769231-78.769231h315.076923a78.769231 78.769231 0 0 1 78.769231 78.769231v315.076923a78.769231 78.769231 0 0 1-78.769231 78.769231zM0.393846 236.307692L236.307692 0.787692 472.221538 236.307692 236.307692 471.827692z\" p-id=\"5194\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/action-library.svg
// module id = i7Si
// module chunks = 29